export default __webpack_public_path__ + "static/media/dark_pointer.6df95240.svg";